<nav class="nav-wrap reusable-container">
  <!-- Loud logo lockup -->
  <a class="logo-lockup" routerLink="/">
    <div class="logo-badge">
      <div class="logo-aurora"></div>
      <img src="../../../../assets/images/emblem.png" alt="e-Mikutano" />
    </div>
    <div class="logo-text">
      <div class="logo-word">
        e<span class="logo-word-accent">Mikutano</span>
      </div>
      <div class="logo-tag">
        <span class="logo-tag-dot"></span>
        Online Meeting Platform
      </div>
    </div>
  </a>

  <!-- Floating pill nav -->
  <div class="hidden lg:flex nav-pill">
    <button class="nav-link" (click)="scrollToSection('features')">
      <mat-icon class="nav-link-icon">auto_awesome</mat-icon>
      Features
    </button>
    <button class="nav-link">
      <mat-icon class="nav-link-icon">menu_book</mat-icon>
      User Manual
    </button>
    <button class="nav-link" (click)="scrollToSection('faq')">
      <mat-icon class="nav-link-icon">help_outline</mat-icon>
      FAQ
    </button>
    <span class="nav-divider"></span>
    <button class="nav-link nav-link-strong" (click)="joinMeeting()">
      <mat-icon class="nav-link-icon">login</mat-icon>
      Join Meeting
    </button>
    <button class="nav-link nav-link-strong" (click)="scheduleMeeting()">
      <mat-icon class="nav-link-icon">event_available</mat-icon>
      Reserve
    </button>
  </div>

  <app-hamburger-button class="lg:hidden"></app-hamburger-button>

  <!-- Right actions -->
  <div class="nav-actions">
    <button
      [matMenuTriggerFor]="menuLang"
      class="nav-lang hidden lg:inline-flex">
      <mat-icon>translate</mat-icon>
      EN
      <mat-icon class="nav-lang-caret">expand_more</mat-icon>
    </button>

    <mat-menu #menuLang="matMenu">
      <mat-list>
        <mat-list-item (click)="changeLanguage('sw')" class="border-b hover:bg-gray-50 !cursor-pointer">
          <span>Kiswahili</span>
        </mat-list-item>
        <mat-list-item (click)="changeLanguage('en')" class="hover:bg-gray-50 !cursor-pointer">
          <span>English</span>
        </mat-list-item>
      </mat-list>
    </mat-menu>

    <button appRipple routerLink="/auth" class="nav-cta">
      <span class="nav-cta-glow"></span>
      <mat-icon>power_settings_new</mat-icon>
      <span>Login</span>
      <mat-icon class="nav-cta-arrow">arrow_forward</mat-icon>
    </button>
  </div>
</nav>
